var _g, _path, _g2, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowsLeftRightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 40,
    viewBox: "0 0 78 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_83_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H40V40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "#9D6464"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1 4.13401 4.13401 1 8 1H39V39H8C4.13401 39 1 35.866 1 32V8Z",
    stroke: "#434343",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_83_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0H70C74.4183 0 78 3.58172 78 8V32C78 36.4183 74.4183 40 70 40H38V0Z",
    fill: "#9D6464"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 1H70C73.866 1 77 4.13401 77 8V32C77 35.866 73.866 39 70 39H39V1Z",
    stroke: "#434343",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8001 20L54.6001 14.8C54.3556 14.5555 54.2334 14.2444 54.2334 13.8667C54.2334 13.4889 54.3556 13.1778 54.6001 12.9333C54.8445 12.6889 55.1556 12.5667 55.5334 12.5667C55.9112 12.5667 56.2223 12.6889 56.4667 12.9333L62.6001 19.0667C62.7334 19.2 62.8278 19.3444 62.8834 19.5C62.939 19.6555 62.9667 19.8222 62.9667 20C62.9667 20.1778 62.939 20.3444 62.8834 20.5C62.8278 20.6555 62.7334 20.8 62.6001 20.9333L56.4667 27.0667C56.2223 27.3111 55.9112 27.4333 55.5334 27.4333C55.1556 27.4333 54.8445 27.3111 54.6001 27.0667C54.3556 26.8222 54.2334 26.5111 54.2334 26.1333C54.2334 25.7555 54.3556 25.4444 54.6001 25.2L59.8001 20Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1999 20L25.3999 25.2C25.6444 25.4445 25.7666 25.7556 25.7666 26.1333C25.7666 26.5111 25.6444 26.8222 25.3999 27.0667C25.1555 27.3111 24.8444 27.4333 24.4666 27.4333C24.0888 27.4333 23.7777 27.3111 23.5333 27.0667L17.3999 20.9333C17.2666 20.8 17.1722 20.6556 17.1166 20.5C17.061 20.3445 17.0333 20.1778 17.0333 20C17.0333 19.8222 17.061 19.6556 17.1166 19.5C17.1722 19.3445 17.2666 19.2 17.3999 19.0667L23.5333 12.9333C23.7777 12.6889 24.0888 12.5667 24.4666 12.5667C24.8444 12.5667 25.1555 12.6889 25.3999 12.9333C25.6444 13.1778 25.7666 13.4889 25.7666 13.8667C25.7666 14.2445 25.6444 14.5556 25.3999 14.8L20.1999 20Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_83_123",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_83_123"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_83_123",
    result: "effect2_innerShadow_83_123"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_83_123",
    x: 38,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_83_123"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_83_123",
    result: "effect2_innerShadow_83_123"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsLeftRightIcon);
export default __webpack_public_path__ + "static/media/arrowsLeftRight-icon.1fd91d7db4143ca113e5f86c9ba1bac4.svg";
export { ForwardRef as ReactComponent };